import React, { useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAppSelector } from '@/store/hooks';
import { refreshActiveTable } from '@/store/reducers/table-slice';
import { getUi, hideModal } from '@/store/reducers/ui-slice';
import { UpdatePayoutStatusDto } from '@alien-platform/bo-core';
import { Button, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useDispatch } from 'react-redux';
import { toast } from 'sonner';

import { InputType } from '@/types/general';
import { CustomConfigInputV2 } from '@/components/core/custom-config-input-v2';

function ApproveRejectWinnerModalContent(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  const content = modal?.content as {
    action: string;
    uuid: string;
  };

  const [dto, setDto] = useState<UpdatePayoutStatusDto>({
    noteForThePlayer: '',
    uuid: content?.uuid,
    confirmerNote: '',
  });

  const urlSearchParams = useSearchParams();
  const selectedOpId = urlSearchParams.get('opId') || undefined;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = (): void => {
    dispatch(hideModal());
  };

  const handleSubmit = async (): Promise<void> => {
    setIsLoading(true);

    try {
      const response = await fetch(`/api/tournament/winners?opId=${selectedOpId}`, {
        method: 'PUT',
        body: JSON.stringify({
          dto,
          action: content?.action,
        }),
      });
      const result = await response.json();
      if (response.ok && result.success) {
        toast.success('Winner payout is updated!');
        dispatch(hideModal());
        dispatch(refreshActiveTable());
      } else {
        toast.error('Error: 500 | Unable to perform this action');
      }
    } catch (e) {
      toast.error('Error: 500 | Unable to perform this action');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack spacing={3}>
      <Typography variant="body2">
        Are you sure you want to {content?.action} this winner prize payout for this player?
      </Typography>

      <CustomConfigInputV2
        label="Note For Player"
        name="noteForThePlayer"
        value={dto.noteForThePlayer}
        type={InputType.MULTILINE_INPUT}
        defaultData={dto}
        setDefaultData={setDto}
      />

      <Stack direction="row" spacing={3} sx={{ mt: 3, justifyContent: 'initial' }}>
        <Button type="button" color="secondary" onClick={handleClose} sx={{ flex: '1 1 auto' }}>
          Close
        </Button>

        <Button loading={isLoading} onClick={handleSubmit} color="info" sx={{ flex: '1 1 auto' }} variant="contained">
          Confirm
        </Button>
      </Stack>
    </Stack>
  );
}

export default ApproveRejectWinnerModalContent;
